import * as React from "react";
const SvgFiRrUserAstronaut = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M20.125 11h.375c.827 0 1.5-.673 1.5-1.5v-2c0-.827-.673-1.5-1.5-1.5h-.375C19.054 2.53 15.817 0 12 0S4.946 2.53 3.875 6H3.5C2.673 6 2 6.673 2 7.5v2c0 .827.673 1.5 1.5 1.5h.375a8.54 8.54 0 0 0 3.049 4.314c-2.85.887-4.925 3.549-4.925 6.686v1a1 1 0 1 0 2 0v-1c0-2.757 2.243-5 5-5h6c2.757 0 5 2.243 5 5v1a1 1 0 1 0 2 0v-1c0-3.137-2.075-5.799-4.925-6.686A8.53 8.53 0 0 0 20.123 11zM5.5 8.5C5.5 4.916 8.416 2 12 2s6.5 2.916 6.5 6.5S15.584 15 12 15a6.51 6.51 0 0 1-6.5-6.5M18 23a1 1 0 1 1-2 0 1 1 0 0 0-1-1H9a1 1 0 0 0-1 1 1 1 0 1 1-2 0c0-1.654 1.346-3 3-3h6c1.654 0 3 1.346 3 3M7 8c0-.343.357-1 1.101-1H16c.716 0 1 .657 1 1A5 5 0 0 1 7 8"
    />
  </svg>
);
export default SvgFiRrUserAstronaut;
